import { render, staticRenderFns } from "./IxMap.vue?vue&type=template&id=e1cae6ba&scoped=true&lang=html&"
import script from "./IxMap.vue?vue&type=script&lang=js&"
export * from "./IxMap.vue?vue&type=script&lang=js&"
import style0 from "./IxMap.vue?vue&type=style&index=0&id=e1cae6ba&lang=scss&scoped=true&"
import style1 from "./IxMap.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1cae6ba",
  null
  
)

export default component.exports